<template>
	<CloPlaylist 
		:list="list"
		:title="title"
		:moreUrl="moreUrl"
		:mediaDownloadUrl="mediaDownloadUrl"
	/>
</template>

<script>
import CloPlaylist from '@/media/CloPlaylist/CloPlaylist.vue';

export default ({
	name: 'SpeciesAudioPlaylist',
	components: {
		CloPlaylist,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		moreUrl: {
			type: String,
			required: true,
		},
		mediaDownloadUrl: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			list: [],
			audioAssets: window.audioAssetsJson
		};
	},
	mounted() {
		this.setMediaData()
	},
	methods: {
		setMediaData() {
			if (this.audioAssets && this.audioAssets.galleryAssets) {
				// from gallery
				this.audioAssets.galleryAssets.forEach(item => {
					// remove location name
					item.asset.locName = null
				})
				this.list = this.audioAssets.galleryAssets
			} else if (this.audioAssets && this.audioAssets.results) {
				// from search results
				this.list = this.audioAssets.results.content;
				this.list[0].asset = {
					assetId: this.list[0].assetId,
					mlBaseDownloadUrl: this.mediaDownloadUrl,
					userDisplayName: this.list[0].userDisplayName,
					title: this.list[0].commonName,
					countryName: this.list[0].locationLine2,
					obsDtDisplay: this.list[0].obsDttm,
					citationUrl: this.list[0].specimenUrl,
					citationName: 'ML ' + this.list[0].assetId,
				}
			}
		},
	}
});
</script>

<style lang="scss">
.Playlist-listen {
	display: flex;
	flex-direction: column;
}
</style>
